// Margem de lucro — "de tudo que entra, quanto sobra pra mim, em %?"
// Sem divisão pro-cliente/minha-cópia (info interna). docs/...spec §3.

export interface MargemLucroInputs {
  /** Quanto vendeu / preço de venda. */
  receita: number
  /** Quanto gastou pra vender (total). */
  custos: number
}

export interface MargemLucroResultado {
  receita: number
  custos: number
  lucro: number
  /** % do faturamento que é lucro (lucro / receita). */
  margem: number
  /** % sobre o custo (lucro / custos) — informação extra. */
  markup: number
  /** lucro < 0 (custos > receita). Nunca esconder. */
  prejuizo: boolean
  /** receita > 0 (senão divisão por zero). */
  calculavel: boolean
}

const round2 = (n: number) => Number(n.toFixed(2))

export function calcularMargemLucro(inputs: MargemLucroInputs): MargemLucroResultado {
  const receita = inputs.receita || 0
  const custos = inputs.custos || 0

  if (receita <= 0) {
    return { receita: 0, custos: round2(custos), lucro: 0, margem: 0, markup: 0, prejuizo: false, calculavel: false }
  }

  const lucro = receita - custos
  const margem = (lucro / receita) * 100
  const markup = custos > 0 ? (lucro / custos) * 100 : 0

  return {
    receita: round2(receita),
    custos: round2(custos),
    lucro: round2(lucro),
    margem: round2(margem),
    markup: round2(markup),
    prejuizo: lucro < 0,
    calculavel: true,
  }
}
